import { jsx } from 'react/jsx-runtime';
import { TermsOfServiceContent } from './Content/TermsOfServiceContent.es.js';
import { TermsOfServiceProvider } from './Provider/provider.es.js';
import { TermsOfServiceScroll } from './Scroll/TermsOfServiceScroll.es.js';
import { TermsOfServiceLoading } from './TermsOfService.Loading.es.js';

const TermsOfService = ({ children, loading })=>{
    if (loading) {
        return jsx(TermsOfServiceLoading, {});
    }
    return jsx(TermsOfServiceProvider, {
        children: children
    });
};
TermsOfService.displayName = 'TermsOfService';
TermsOfService.Content = TermsOfServiceContent;
TermsOfService.Scroll = TermsOfServiceScroll;

export { TermsOfService, TermsOfService as default };
//# sourceMappingURL=TermsOfService.es.js.map
